import { useEffect, useState } from 'react';
import { AscDesc, Channel } from 'stream-chat';
import { Session } from '@bizzabo/entities';
import { useChatClient } from '@bizzabo/chat-core';
import { CHANNEL_TYPE } from '../consts/channel';
import { joinToChannels } from '../utils/joinChannels';

const useChannels = (
    accountId: number,
    eventId: number,
    session: Session,
    isJoinChannelAsync = false
) => {
    const [channels, setChannels] = useState<Channel[]>(null);
    const { client } = useChatClient();

    useEffect(() => {
        const queryChannels = async () => {
            const sessionChannels = session?.chat?.channels;

            if (!client || !sessionChannels?.length) {
                return;
            }
            const sort = [{ last_message_at: -1 as AscDesc }];
            const filter = {
                cid: {
                    $in: sessionChannels.map(channel => `${CHANNEL_TYPE}:${channel.channelId}`),
                },
            };

            try {
                const channels = await client.queryChannels(filter, sort, {
                    watch: true,
                    state: true,
                });

                setChannels(channels);
            } catch (e) {
                await joinToChannels(accountId, eventId, session);
                const channels = await client.queryChannels(filter, sort, {
                    watch: true,
                    state: true,
                });
                setChannels(channels);
            }
        };

        if (!isJoinChannelAsync) {
            queryChannels();
        }
    }, [client, session]);

    return { channels };
};

export default useChannels;
